import {createStore,applyMiddleware, compose } from "redux";
import { createBrowserHistory } from 'history'
import createSagaMiddleware from "redux-saga";
import reducers from "./reducers/index";
import rootSaga from "./sagas/index";


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const history = createBrowserHistory()
// create the saga middleware
const sagaMiddleware = createSagaMiddleware();
const store = createStore(
    reducers, 
    composeEnhancers(applyMiddleware(sagaMiddleware))
);

// Run the saga

sagaMiddleware.run(rootSaga);

export default store;
